import styles from "../../styles/Layout/Transactions/TransactionsLayoutSidebar.module.css"
import React, { useContext } from 'react'
import { NavLink } from "react-router-dom";
import SettingsIcon from '@mui/icons-material/Settings';
import { ThemeContext } from "../../context/ThemeContext";
import { LangContext } from "../../context/LangContext";
import { getTransactionActionLabel } from "../../utils/transactionActionLabels";

const translations = {
  ru: {
    all: "Все",
    deposit: "Депозит",
    withdrawal: "Вывод",
    filters: "Фильтры",
  },
  en: {
    all: "All",
    deposit: "Deposit",
    withdrawal: "Withdrawal",
    filters: "Filters",
  },
};

export const TransactionsLayoutSidebar = ({ onOpenSettings }) => {
  const { langSelected } = useContext(LangContext);
  const { theme } = useContext(ThemeContext);
  const t = translations[langSelected] || translations.ru;

  const containerClass = `${styles.container} ${theme === 'dark' ? styles.darkContainer : ''}`;
  const tabButtonClass = ({ isActive }) => 
    `${styles.tabButton} ${isActive ? styles.active : ''} ${theme === 'dark' ? styles.darkTabButton : ''}`;

  return (
    <div className={containerClass}>
      <div className={styles.navigation}>
        <NavLink 
          to="/transactions/all"
          className={tabButtonClass}>
          {t.all}
        </NavLink>

        <NavLink
          to="/transactions/deposit"
          className={tabButtonClass}>
          {t.deposit}
        </NavLink>

        <NavLink 
          to="/transactions/withdrawal"
          className={tabButtonClass}>
          {t.withdrawal}
        </NavLink>

        <NavLink
          to="/transactions/bonus"
          className={tabButtonClass}>
          {getTransactionActionLabel('bonus', langSelected)}
        </NavLink>
      </div>

      <div className={styles.action}>
        <div className={styles.filter}>
          <button className={`${styles.filterButton} ${theme === 'dark' ? styles.darkFilterButton : ''}`}>
            {t.filters}
          </button>
        </div>

        <button className={`${styles.settingsButton} ${theme === 'dark' ? styles.darkSettingsButton : ''}`} onClick={onOpenSettings}>
            <SettingsIcon style={{ fontSize: '18px' }}/>
        </button>
      </div>
    </div>
  );
};
